import React from 'react';

import { PageTitle } from '../../../components';
import { Gallery } from '../../../sections';



const GalleryPage = () => {

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Gallery'} page={'Gallery'} />

      <Gallery />
    </>
  );
};

export default GalleryPage;